function isLoggedIn(meData) {
    return meData && meData.email;
}

export { isLoggedIn };
